import React from "react";
import { Link } from "react-router-dom";
import { useEffect } from "react";

const Section = ({ title, children }) => (
  <div className="bg-white rounded-2xl shadow-md p-6 hover:shadow-lg transition">
    <h2 className="text-xl font-semibold text-[#0c5a87] mb-4">{title}</h2>
    {children}
  </div>
);

const Sitemap = () => {

  useEffect(() => {
      window.scrollTo(0, 0);
    }, []);

  return (
    <div className="bg-gray-100 py-16">
      <div className="max-w-7xl mx-auto px-6">

        {/* Header */}
        <div className="text-center mb-14">
          <h1 className="text-4xl font-bold text-[#0c5a87] mb-3">
            Website Sitemap
          </h1>
          <p className="text-gray-600">
            Explore all pages and services of SoftCoder
          </p>
        </div>

        {/* Grid Layout */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">

          {/* MAIN */}
          <Section title="🏠 Main Pages">
            <ul className="space-y-2">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/contact">Contact</Link></li>
              <li><Link to="/blog">Blog</Link></li>
              <li><Link to="/careers">Careers</Link></li>
            </ul>
          </Section>

          {/* SOFTWARE */}
          <Section title="💻 Software Services">
            <ul className="space-y-2">
              <li><Link to="/Custom-Software-Page">Custom Software</Link></li>
              <li><Link to="/web-application-development">Web Apps</Link></li>
              <li><Link to="/mobile-app-development">Mobile Apps</Link></li>
              <li><Link to="/software-as-a-service-development">Software as a Service</Link></li>
              <li><Link to="/api-development">API Integration</Link></li>
            </ul>
          </Section>

          {/* ERP */}
          <Section title="🏫 ERP Solutions">
            <ul className="space-y-2">
              <li><Link to="/school-erp-software">GuruKul School ERP</Link></li>
              <li><Link to="/Beacon-Track-Billing-Software">Beacon Track - Billing Software</Link></li>
              <li><Link to="/hr-management-software">Kings Printer</Link></li>
              <li><Link to="/accounting-software">Bud & Tulips</Link></li>
              <li><Link to="/accounting-software">HSF Foods</Link></li>
              <li><Link to="/accounting-software">Vyaapak Prints</Link></li>
              <li><Link to="/accounting-software">Paryavaran Prerna</Link></li>
            </ul>
          </Section>

          {/* WEB */}
          <Section title="🌐 Web & Marketing">
            <ul className="space-y-2">
              <li><Link to="/website-development">Website Development</Link></li>
              <li><Link to="/ecommerce-development">E-commerce</Link></li>
              <li><Link to="/seo-services">SEO</Link></li>
              <li><Link to="/digital-marketing">Digital Marketing</Link></li>
            </ul>
          </Section>

          {/* STATES */}
          <Section title="📍 Services by State">
            <ul className="space-y-2">
              <li><Link to="/software-development-haryana">Haryana</Link></li>
              <li><Link to="/software-development-punjab">Punjab</Link></li>
              <li><Link to="/software-development-uttarpradesh">Uttar Pradesh</Link></li>
              <li><Link to="/software-development-rajasthan">Rajasthan</Link></li>
              <li><Link to="/software-development-delhi">Delhi</Link></li>
            </ul>
          </Section>

          {/* CITY */}
          <Section title="📍 Services by City">
            <ul className="space-y-2">
              <li><Link to="/software-development-gurugram/haryana">Gurugram</Link></li>
              <li><Link to="/software-development-noida/uttarpradesh">Noida</Link></li>
              <li><Link to="/software-development-jaipur/rajasthan">Jaipur</Link></li>
              <li><Link to="/software-development-lucknow/uttarpradesh">Lucknow</Link></li>
              <li><Link to="/software-development-sirsa/haryana">Sirsa</Link></li>
            </ul>
          </Section>

          {/* BLOG */}
          <Section title="📝 Blog">
            <ul className="space-y-2">
              <li><Link to="/blog/custom-software-for-startups">Software Dev</Link></li>
              <li><Link to="/blog/affordable-web-development-services">Web Development </Link></li>
              <li><Link to="/blog/how-ai-is-transforming-modern-businesses">AI</Link></li>
              <li><Link to="/blog/digital-marketing-strategies-2026">Marketing</Link></li>
            </ul>
          </Section>

          {/* CONTACT */}
          <Section title="📞 Contact">
            <p>Email: Info@softcoders.in</p>
            <p>Phone: +91 8295000455</p>
          </Section>

          {/* LEGAL */}
          <Section title="🔗 Legal">
            <ul className="space-y-2">
              <li><Link to="/">Privacy Policy</Link></li>
              <li><Link to="/">Terms & Conditions</Link></li>
            </ul>
          </Section>

        </div>
      </div>
    </div>
  );
};

export default Sitemap;